import axios, { type AxiosInstance } from 'axios';

console.log("Vite",import.meta.env.VITE_API_BASE_URL)
export const apiClient: AxiosInstance = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL,
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    },
    timeout: 35000
});

